<template>
  <div>
    <template v-if="!domain">
      <div
        class="alert alert-info d-flex align-items-center"
        role="alert"
        style="margin-top: 30px"
      >
        <div class="spinner-border spinner-border-sm mr-2" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <em>Loading the domain's details... Please wait.</em>
      </div>
    </template>
    <template v-else>
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3"
      >
        <h1
          class="h2"
          v-bind:class="{
            'text-success': domain.active,
            'text-danger': !domain.active,
          }"
        >
          <span class="clickable-email" @click="copyEmailToClipboard">
            {{ domain.display | capitalize }}
            <span class="copy-indicator">{{ copyText }}</span>
          </span>
          <span
            v-if="domain.is_ban"
            v-bind:title="
              domain.ban_reason ? 'banned: ' + domain.ban_reason : 'banned'
            "
            >&#x1f512;</span
          >
          <small
            v-if="domain.is_ban && domain.ban_reason"
            class="text-muted"
            style="font-size: 0.5em; font-weight: normal"
            >banned: {{ domain.ban_reason }}</small
          >
          <span v-if="domain.active">
            <i class="icon ion-md-checkmark-circle-outline"></i>
          </span>
          <span v-else title="forwarding disabled">
            <CircleAlertIcon />
          </span>
        </h1>
        <router-link
          :to="{
            name: 'account-details',
            params: { email: domain.account.email },
          }"
          style="font-size: 1.5em"
        >
          Account: {{ getName(domain.account) | capitalize }}
          <i class="icon ion-md-link"></i>
        </router-link>
      </div>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link
            :to="{
              name: 'domain-details',
              params: { domain: $route.params.domain },
            }"
            class="nav-link"
            active-class="active"
            :exact="true"
            >Details</router-link
          >
        </li>
        <li class="nav-item" v-if="showAliasesTab">
          <router-link
            :to="{
              name: 'domain-aliases',
              params: { domain: $route.params.domain },
            }"
            class="nav-link"
            active-class="active"
            :exact="true"
            >Aliases</router-link
          >
        </li>
        <li class="nav-item" v-if="domain.routing_engine == 'rules'">
          <router-link
            :to="{
              name: 'domain-rules',
              params: { domain: $route.params.domain },
            }"
            class="nav-link"
            active-class="active"
            :exact="true"
            >Rules</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{
              name: 'domain-logs',
              params: { domain: $route.params.domain },
            }"
            class="nav-link"
            active-class="active"
            >Logs</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{
              name: 'domain-smtp-credentials',
              params: { domain: $route.params.domain },
            }"
            class="nav-link"
            active-class="active"
            :exact="true"
            >SMTP Credentials</router-link
          >
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active show">
          <router-view />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CircleAlertIcon from "@/components/CircleAlertIcon.vue";

export default {
  components: { CircleAlertIcon },
  data() {
    return {
      domain: null,
      copyText: "Copy",
    };
  },
  computed: {
    showAliasesTab() {
      if (!this.domain || this.domain.routing_engine === "rules") return false;
      return (
        this.domain.routing_engine === "alias" || this.domain.aliases.total > 0
      );
    },
  },
  created() {
    this.$http.get("domains/" + this.$route.params.domain).then(
      (response) => {
        this.domain = response.body.domain;
      },
      (response) => {
        if (response.status === 401) return;
        alert("A fatal error occured!");
      },
    );
  },
  methods: {
    getName(account) {
      if (account.company_name) {
        return account.company_name;
      }
      return account.email
        .split("@")[0]
        .replace(".", " ")
        .replace("-", " ")
        .replace("_", " ")
        .replace("+", " ");
    },
    copyEmailToClipboard() {
      navigator.clipboard.writeText(this.domain.display);
      this.copyText = "Copied";
      setTimeout(() => {
        this.copyText = "Copy";
      }, 2000);
    },
  },
};
</script>

<style scoped>
.card .card-header.card-hidden + .card-body {
  display: none;
}

.clickable-email {
  cursor: pointer;
  position: relative;

  .copy-indicator {
    font-size: 0.5em;
    color: rgb(148, 163, 184);
    opacity: 0;
    display: none;
    transition: opacity 0.2s ease;
  }

  &:hover {
    .copy-indicator {
      opacity: 1;
      display: inline-block;
    }
  }
}
</style>
